import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

export enum Category {
	MESSAGE_FROM_ADMIN = 'MESSAGE_FROM_ADMIN',
    REQUEST_MANAGEMENT_SERVICES_RECEIVED = 'REQUEST_MANAGEMENT_SERVICES_RECEIVED',
    REQUEST_MANAGEMENT_SERVICES_ACCEPTED = 'REQUEST_MANAGEMENT_SERVICES_ACCEPTED',
    REQUEST_MANAGEMENT_SERVICES_REJECTED = 'REQUEST_MANAGEMENT_SERVICES_REJECTED',
    REQUEST_MANAGEMENT_SERVICES_CANCELLED = 'REQUEST_MANAGEMENT_SERVICES_CANCELLED',
    REQUEST_CLEANING_SERVICES_RECEIVED = 'REQUEST_CLEANING_SERVICES_RECEIVED',
    REQUEST_CLEANING_SERVICES_ACCEPTED = 'REQUEST_CLEANING_SERVICES_ACCEPTED',
    REQUEST_CLEANING_SERVICES_REJECTED = 'REQUEST_CLEANING_SERVICES_REJECTED',
    REQUEST_CLEANING_SERVICES_CANCELLED = 'REQUEST_CLEANING_SERVICES_CANCELLED',
    REQUEST_CLEANING_RECEIVED = 'REQUEST_CLEANING_RECEIVED',
	REQUEST_CLEANING_MODIFIED = 'REQUEST_CLEANING_MODIFIED',
	REQUEST_CLEANING_CANCELLED = 'REQUEST_CLEANING_CANCELLED',
	REQUEST_CLEANING_ASSIGNED = 'REQUEST_CLEANING_ASSIGNED',
	REQUEST_CLEANING_STARTED = 'REQUEST_CLEANING_STARTED',
	REQUEST_CLEANING_ENDED = 'REQUEST_CLEANING_ENDED',
	REQUEST_CLEANING_RECURRENCE_STOPPED = 'REQUEST_CLEANING_RECURRENCE_STOPPED',
	REQUEST_CLEANING_COMMENTED = 'REQUEST_CLEANING_COMMENTED',
	INVITATION_RECEIVED = 'INVITATION_RECEIVED',
	INVITATION_ACCEPTED = 'INVITATION_ACCEPTED',
	INVITATION_REJECTED = 'INVITATION_REJECTED',
    REQUEST_PAYMENT_RECEIVED = 'REQUEST_PAYMENT_RECEIVED',
	REQUEST_PAYMENT_REJECTED = 'REQUEST_PAYMENT_REJECTED',
	REQUEST_PAYMENT_PAID = 'REQUEST_PAYMENT_PAID',
	REQUEST_PAYMENT_UPDATED = 'REQUEST_PAYMENT_UPDATED',
	REQUEST_PAYMENT_ENDED = 'REQUEST_PAYMENT_ENDED',
	PROPERTY_MANAGEMENT_STOPPED = 'PROPERTY_MANAGEMENT_STOPPED',
	PROPERTY_CLEANING_STOPPED = 'PROPERTY_CLEANING_STOPPED',
	PROPERTY_CLEANING_MODIFIED = 'PROPERTY_CLEANING_MODIFIED',
	REVIEW_CREATED = 'REVIEW_CREATED',
	REVIEW_UPDATED = 'REVIEW_UPDATED',
	REVIEW_DELETED = 'REVIEW_DELETED',
	REVIEW_CREATED_ADMIN = 'REVIEW_CREATED_ADMIN',
	REVIEW_UPDATED_ADMIN = 'REVIEW_UPDATED_ADMIN',
	REVIEW_DELETED_ADMIN = 'REVIEW_DELETED_ADMIN',
	CHAT_CREATED = 'CHAT_CREATED',
	PROPERTY_RENTAL_ENDED = "PROPERTY_RENTAL_ENDED",
};

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {

	constructor(
		public apiService: ApiService,
	) {
	}

	getNotifications( page: number, token: string ) {

		var body: any;

		body = {};

		return this.apiService.get('/notifications/list?page=' + page, body, token).pipe(response => response);

	}

	getNotificationsCounter( token: string ) {

		var body: any;

		body = {};

		return this.apiService.get('/notifications/counter', body, token).pipe(response => response);

	}

	markAsRead( id: any, token: string ) {

		var body: any;

		body = {id: id};

		return this.apiService.post('/notifications/markAsRead', body, token).pipe(response => response);

	}

	markAllAsRead( token: string ) {

		var body: any;

		body = {};

		return this.apiService.post('/notifications/markAllAsRead', body, token).pipe(response => response);

	}

	addPushNotificationsToken( notification_token: string, platform: string, token: string ) {

		var body: any;

		body = {token: notification_token, platform: platform};

		return this.apiService.post('/notifications/addPushNotificationsToken', body, token).pipe(response => response);

	}

	resetPushNotificationsTokens( token: string ) {

		var body: any;

		body = {};

		return this.apiService.post('/user/resetPushNotificationsTokens', body, token).pipe(response => response);

	}

}